var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{class:['SocialIcon', _vm.data.class, _vm.data.staticClass],attrs:{"href":_vm.props.href,"rel":"noopener","target":"_blank","title":_vm.props.title}},[_c('Icon',{attrs:{"name":_vm.props.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }